import React from "react";
import { getClassesString } from "../../utils";

const Input = React.forwardRef(
  ({ inputClasses, type = "text", placeholder = "", ...props }, ref) => {
    return (
      <input
        className={`border border-gray-300 px-3 py-2 placeholder-gray-400 placeholder-text-xs font-light text-sm text-black bg-white rounded focus:outline-none focus:ring-1 w-full ease-linear transition-all duration-150 ${getClassesString(
          inputClasses
        )}`}
        type={type}
        placeholder={placeholder}
        {...props}
        ref={ref}
      />
    );
  }
);

export default Input;
